// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-form-item--mini.el-form-item[data-v-6b99ccac] {\n  margin-bottom: 10px;\n}\n[data-v-6b99ccac] .search-form .el-input--suffix {\n  width: 178px;\n}", ""]);
// Exports
module.exports = exports;
